import { Pipe, PipeTransform } from '@angular/core';
import { FeatureFlag } from '../directives/show-feature.directive';
import { FeatureFlagService } from '../services/feature-flag.service';
import { Observable } from 'rxjs';
import { PanAppState } from '@panamax/app-state';

@Pipe({
  name: 'showFeature',
})
export class ShowFeaturePipe implements PipeTransform {
  /**
   * @deprecated
   * use showPlit pipe versus the showFeature pipe
   */
  constructor(private featureFlag: FeatureFlagService) {}

  transform(flags: FeatureFlag): boolean {
    return this.featureFlag.show(flags);
  }
}

@Pipe({
  name: 'showSplit',
})
export class ShowSplitPipe implements PipeTransform {
  constructor(private panAppState: PanAppState) {}

  transform(features: string[], allEnabled = true): Observable<boolean> {
    return this.panAppState.feature$(features, allEnabled);
  }
}
